import i18n from "@/plugins/i18n";
export default {
  browse: {
    table: {
      headers: [
        {
          text: i18n.t("model.prop.no"),
          value: "index",
          sortable: false,
          filterable: false,
        },
        {
          text: "Tuition Name",
          value: "Tuition",
        },
        {
          text: "Mochi Id",
          value: "playerMochiId",
        },
        {
          text: "Avatar",
          value: "avatar",
        },
        {
          text: "Level",
          value: "level",
        },
      ],
    },
  },
  read: false,
  add: false,
  edit: false,
  delete: false,
};
